export function isMouseOver(element: HTMLElement, event: React.MouseEvent) {
  const bounds = element.getBoundingClientRect();
  const mouseX = event.clientX + document.body.scrollLeft;
  const mouseY = event.clientY + document.body.scrollTop;
  if (
    mouseX >= bounds.left &&
    mouseX <= bounds.left + bounds.width &&
    mouseY >= bounds.top &&
    mouseY <= bounds.top + bounds.height
  ) {
    return true;
  } else {
    return false;
  }
}
